/** Public bot config written to S3 at bots/<slug>/config.json */
export interface PublishedBotConfig {
  version: 1;
  id: string;
  name: string;
  slug: string;
  agentId: string;
  agentName?: string;
  apiBase: string;
  theme: {
    preset: string;
    mode: 'light' | 'dark';
    accent: string | null;
    radiusBase: number | null;
    density: 'comfortable' | 'compact';
    fontKey: string;
    areas?: Record<string, Record<string, string>>;
  };
  resolved: {
    dataAttrs: {
      'data-theme': string;
      'data-mode'?: 'dark';
      'data-density'?: 'compact';
    };
    inlineVars: Record<string, string>;
  };
  publishedAt: number;
}

export async function fetchPublishedBot(slug: string): Promise<PublishedBotConfig> {
  const res = await fetch(`/bots/${encodeURIComponent(slug)}/config.json`, {
    cache: 'no-store',
  });
  if (!res.ok) {
    throw new Error(
      res.status === 404 ? '배포된 챗봇을 찾을 수 없어요.' : `설정을 불러오지 못했어요 (${res.status})`,
    );
  }
  const data = (await res.json()) as PublishedBotConfig;
  if (data?.version !== 1 || !data.slug) {
    throw new Error('설정 형식이 올바르지 않아요.');
  }
  return data;
}
